import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { P11, Particles } from "./p11shared";
import { useP11Lang } from "./p11lang";
import { PixelField, TechnicalGlyph, useP11Sound } from "./p11fx";

// Digitale identiteit: dot-matrix reveal → schermnaam + random nummer. Kort en skippable.
export default function P11Identity() {
  const nav = useNavigate();
  const { lang, tt } = useP11Lang();
  const { play } = useP11Sound();
  const [data, setData] = useState(null);
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    api.get("/project11/me/dashboard").then(({ data }) => setData(data)).catch(() => nav("/project11/login"));
  }, [nav]);
  useEffect(() => {
    if (!data) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    play("confirm");
    const t = setTimeout(() => setRevealed(true), reduced ? 0 : 1400);
    return () => clearTimeout(t);
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return <div className="p11-root min-h-screen flex items-center justify-center"><span className="p11-label">…</span></div>;
  const name = (data.participant.first_name || "").toUpperCase();

  return (
    <div className="p11-root relative" data-testid="p11-identity">
      <Particles />
      <main className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-6">
        <div className="p11-label mb-2" data-testid="p11-identity-system">{tt("identity_system")}</div>
        <div className="flex items-center gap-8 mb-10 p11-label">
          <span className="p11-label-yellow">{tt("identified")}</span>
          <span>{lang === "nl" ? "TOEGANG / VERLEEND" : "ACCESS / GRANTED"}</span>
          <span>NOV. 2026</span>
        </div>
        {/* identiteits-reveal: dot-matrix organiseert → nummer verschijnt */}
        <div className="h-28 flex items-center justify-center mb-2" data-testid="p11-identity-reveal">
          {!revealed
            ? <PixelField size={104} density={8} testid="p11-identity-pixels" />
            : <TechnicalGlyph type="crosshair" size={26} active testid="p11-identity-crosshair" />}
        </div>
        <div className="p11-label">{tt("screen_name")}</div>
        <div className="p11-h2 text-3xl md:text-4xl mt-3 p11-fade-in" data-testid="p11-identity-name">{name}</div>
        <div className="w-16 h-px mt-8" style={{ background: P11.border }} />
        <div className="p11-h1 mt-10 p11-reveal-anim" style={{ color: P11.yellow, fontSize: "clamp(72px, 18vw, 160px)", opacity: revealed ? 1 : 0, transition: "opacity 0.4s" }} data-testid="p11-identity-number">
          {data.number_display || "#———"}
        </div>
        <div className="p11-label mt-10">{tt("id_confirmed")}</div>
        <div className="p11-label-yellow mt-2">{tt("status_active")}</div>
        <button onClick={() => nav("/project11/dashboard", { replace: true, state: { firstVisit: true } })} className="p11-btn mt-14" data-testid="p11-identity-enter">{tt("enter_project")}</button>
      </main>
    </div>
  );
}
